import react, { useState, useEffect } from 'react';
import { Modal, Form, Select, Checkbox, Input } from 'antd';
import useFetch from '../../../../commons/useFetch';
import MediaModal from './MediaModal';
import EndowModal from './EndowModal';
import Slider from "react-slick";
function Payment({ valueSearch, dateValue}) {
    const { data: Medias } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/Medias/' + valueSearch[0].id);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [endowModal, setEndowModal] = useState(false);
    const [payment, setPayment] = useState(1);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [day, setDay] = useState()
    const [night, setNight] = useState()

    const showMediaModal = () => {
        setIsModalVisible(true)
    }
    const handleCancel = () => {
        setIsModalVisible(false)
    }
    
    window.addEventListener('resize', handleResize)
    function handleResize() {
        setScreenWidth(window.innerWidth)
    }

    const showEndowModal = () => {
        setEndowModal(true)
    }

    const handlePaymentNow=()=>{
        setPayment(1)
    }
    const handlePaymentPostpaid = () => {
        setPayment(2)
    }

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        prevArrow: (
            <div>
                <img src="/images/ic_prev1.png" />
            </div>
        ),
        nextArrow: (
            <div>
                <img src="/images/ic_next1.png" />
            </div>
        ),
    };
    useEffect(() => {
        const date1 = new Date(dateValue[0]);
        const date2 = new Date(dateValue[1]);

        const oneDay = 24 * 60 * 60 * 1000;

        const dayNumber = Math.round(Math.abs((date2 - date1) / oneDay));
        
        if (dayNumber === 0) {
            setDay(dayNumber + 1)
            setNight(dayNumber + 1)
        }
        else {
            setDay(dayNumber)
            setNight(dayNumber - 1)
        }
    }, [day, night])
    return (
        <>
            <div className="bookingRoom">
                <div className="roomInfo">
                    <div className="row ">
                        <div className="col-lg-7 col-md-7">
                            {screenWidth < 768 ?
                                (<div className="slideMedia">
                                    <Slider {...settings}>
                                        {Medias.image && Medias.image.map(item => {
                                            return (
                                                <div className="item">
                                                    <img className="img-fluid" src={item.photo} alt="" />
                                                </div>
                                            )
                                        })}
                                    </Slider>
                                </div>)
                                :
                                (<div className="row">
                                    <div className="col-lg-9 col-md-9">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 colBox">
                                                <img className="img-fluid" src="images/hotels-1612754408929.png" alt="" />
                                            </div>
                                            <div className="col-lg-6 col-md-6 colBox">
                                                <img className="img-fluid" src="/images/hotels-1612754408934.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 colBox">
                                        <div className="album">
                                            <img className="img-fluid" src="images/hotels-1612754408936.png" alt="" />
                                            <div className="albumQuatity" onClick={showMediaModal}>
                                                <span>+</span><span>16</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                            }
                        </div>
                        <div className="col-lg-5 col-md-5">
                            <div className="infoBox">
                                <h5 className="hotelName">{valueSearch[0].name}</h5>
                                <div className="dateTime">
                                    <div className="time"><img className="img-fluid" src="/images/ic_date.png" alt="" /><span>{dateValue[0]} - {dateValue[1]}</span></div>
                                    <div className="night"><span>{day} ngày {night} đêm</span></div>
                                </div>
                                <div className="location"><img className="img-fluid" src="/images/ic_location1.png" alt="" /><span>{valueSearch[0].address}</span></div>
                                <div className="line"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bookingUser">
                    <div className="avatarForm">
                        <img className="img-fluid" src="images/avatar.png" alt="" />
                    </div>
                    <div className="slogan">Chào mừng JO đã quay trở lại. Có rất nhiều thứ đã thay đổi khi JO rời đi nhưng chúng tôi vẫn ở đây đợi bạn hoàn tất đặt phòng!</div>
                </div>
                <div className="PaymentInfo formSyleInfo">
                    <Form>
                        <div className="row">
                            <div className="col-lg-7 col-md-7">
                                <div className="bookingInfoStyle">
                                    <div className="guest_room">
                                        <h5 className="title">THÔNG TIN NGƯỜI ĐẶT PHÒNG</h5>
                                        <div className="guestInfo">
                                            <div className="row">
                                                <div className="col-lg-6 col-12">
                                                    <Form.Item label="Họ tên" name="fullname" className="formInput">
                                                        <Input placeholder="Nhập họ tên của bạn" />
                                                    </Form.Item>
                                                </div>
                                                <div className="col-lg-6 col-12">
                                                    <Form.Item label="Số điện thoại" name="phoneNumber" className="formInput">
                                                        <Input placeholder="Nhập số điện thoại" />
                                                    </Form.Item>
                                                </div>
                                                <div className="col-lg-6 col-12">
                                                    <Form.Item label="Email" name="email" className="formInput">
                                                        <Input placeholder="Nhập Email" />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <Form.Item name="luutru" className="checkBoxStyle">
                                                <Checkbox >Tôi là khách lưu trú</Checkbox>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className="otherInfo">
                                        <h5 className="title">THÔNG TIN KHÁCH LƯU TRÚ</h5>
                                        <div className="row">
                                            <div className="col-lg-6 col-12">
                                                <Form.Item label="Họ tên" name="fullnameother" className="formInput">
                                                    <Input placeholder="Nhập họ tên của bạn" />
                                                </Form.Item>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <Form.Item label="Số điện thoại" name="phoneNumberother" className="formInput">
                                                    <Input placeholder="Nhập số điện thoại" />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-5">
                                <div className="bookingPayment">
                                    <div className="bookingPaymentStyle" style={{ backgroundImage: `url('/images/wave.png')` }}>
                                        <div className="headerBookingPaymentMain">
                                            <h5>Tóm tắt giá</h5>
                                            <div className="chooseEndows" onClick={showEndowModal}>Chọn ưu đãi</div>
                                        </div>
                                        <ul>
                                            <li>
                                                <label htmlFor="">Giá bán</label>
                                                <span>42,549,000 VND</span>
                                            </li>
                                            <li>
                                                <label htmlFor="">Tạm tính</label>
                                                <span>42,549,000 VND</span>
                                            </li>
                                            <li className="totalPrice">
                                                <label htmlFor="">Tổng tiền</label>
                                                <span>42,549,000 VND</span>
                                            </li>
                                        </ul>
                                    </div>
                                    {payment === 1 && 
                                        <div className="paymentMethod">
                                            <h5 className="title">PHƯƠNG THỨC THANH TOÁN</h5>
                                            <div className="cart"><img className="img-fluid" src="/images/ic_one_pay.png" alt="" /></div>
                                            <Form.Item name="billcheck" className="checkBoxStyle">
                                                <Checkbox >TÔI MUỐN XUẤT HÓA ĐƠN</Checkbox>
                                            </Form.Item>
                                            <p>Hóa đơn sẽ được gửi tới bạn 48h sau khi trả phòng. Vui lòng cung cấp các thông tin cần thiết</p>
                                        </div>
                                    }
                                    
                                    <Form.Item name="luutru" className="checkBoxStyle">
                                        <Checkbox >
                                            Tôi đã đọc và đồng ý với chính sách của SOJO</Checkbox>
                                    </Form.Item>
                                    <div className="btnPayment">
                                        <button><img className="img-fluid" src="/images/ic_button_booking.png" alt="" />Hoàn tất đặt phòng
                                        </button>
                                    </div>
                                    <div className="movePayment" >
                                        {payment === 1 && <div className="moveLink" onClick={handlePaymentPostpaid}>Chuyển thành thanh toán sau</div>}
                                        {payment === 2 && <div className="moveLink" onClick={handlePaymentNow}>Chuyển thành thanh toán ngay</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
            <Modal className="modalMedia" title={""} footer={false} visible={isModalVisible} width={900} onCancel={handleCancel}>
                <MediaModal img={Medias.image} />
            </Modal>
            <EndowModal endowModal={endowModal} setEndowModal={setEndowModal} />
        </>
    );
}
export default Payment;